module.exports = __webpack_public_path__ + "img/logo.958c23df.png";